import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.429 5a.7.7 0 0 1 .7.7v8.595a.7.7 0 0 1-1.4 0V5.7a.7.7 0 0 1 .7-.7m7.625.198a.7.7 0 0 1 .024.99l-3.635 3.814 3.635 3.815a.7.7 0 0 1-1.013.966l-4.096-4.298a.7.7 0 0 1 0-.965l4.096-4.298a.7.7 0 0 1 .99-.024"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
